module.exports = __webpack_public_path__ + "media/images/p-about/example/okayama-sib-26d7747b1dfb085fbfb6b6abfe533ccb.png";